import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-stethoscope',
    templateUrl: './stethoscope.component.svg',
    styleUrls: ['./stethoscope.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StethoscopeComponent {}
